import { createRoot } from 'react-dom/client';
import 'froala-editor/js/froala_editor.pkgd.min';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ApolloClient, InMemoryCache, HttpLink, ApolloProvider, from, ApolloLink } from '@apollo/client';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
// import { fas } from '@fortawesome/pro-solid-svg-icons';
// import { far } from '@fortawesome/pro-regular-svg-icons';
// import { faTint } from '@fortawesome/pro-solid-svg-icons';
import Public from './components/public';
import Admin from './components/admin/main';
import Preview from './components/preview';
import MenuProvider from './components/page/menu';
import data from './data.json';
import Mutation from './resolvers';
import { CLIENT_STATE } from './graphqls';

library.add(fal);
// library.add(fas, far);
const { token, corporationId, serverUri } = window;
const httpLink = new HttpLink({
  uri: serverUri === '__SERVER_URI__' ? `http://${window.location.hostname}:8888/graphql` : serverUri,
  credentials: 'include',
});
const authorization = `BASE ${token}`;
const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization,
      corporationId,
    },
  }));

  return forward(operation);
});
const link = from([authMiddleware, httpLink]);
const cache = new InMemoryCache({
  dataIdFromObject: (obj) => {
    const { cache: { planNodeId, measureId, __typename: pageType } = {}, __typename: objType } = obj;

    if (objType === 'PageData') {
      switch (pageType) {
        case 'PlanNodePage':
          return planNodeId;
        case 'MeasurePage':
          return measureId;
        default:
          return 'home';
      }
    }

    return null;
  },
});
const client = new ApolloClient({
  link,
  resolvers: { Mutation },
  cache,
});
cache.writeQuery({
  query: CLIENT_STATE,
  data,
});
const observer = new MutationObserver(() => {
  document.querySelectorAll('iframe:not([title])').forEach((frame) => frame.setAttribute('title', 'Framed Content'));
  document.querySelectorAll('img:not([alt])').forEach((img) => img.setAttribute('alt', 'Uploaded Image'));
  document.querySelectorAll('svg[width="96px"]').forEach((svg) => svg.setAttribute('aria-hidden', 'true'));
});
observer.observe(document.getElementById('root'), { attributes: false, childList: true, subtree: true });

const root = createRoot(document.getElementById('root'));

root.render(
  <ApolloProvider client={client}>
    <BrowserRouter basename="/">
      <MenuProvider>
        <Switch>
          <Route
            path="/dashboard/:subdomain/:pageId?"
            render={({
              match: {
                params: { subdomain },
              },
            }) => <Public branding linkPrefix={`/dashboard/${subdomain}`} />}
          />
          <Route
            path="/dashboard-brandoff/:subdomain/:pageId?"
            render={({
              match: {
                params: { subdomain },
              },
            }) => <Public branding={false} linkPrefix={`/dashboard-brandoff/${subdomain}`} />}
          />
          <Route
            path="/public/:subdomain/:pageId?"
            render={({
              match: {
                params: { subdomain },
              },
            }) => <Public branding linkPrefix={`/public/${subdomain}`} />}
          />
          <Route
            path="/public-brandoff/:subdomain/:pageId?"
            render={({
              match: {
                params: { subdomain },
              },
            }) => <Public branding={false} linkPrefix={`/public-brandoff/${subdomain}`} />}
          />
          <Route
            path="/preview/:subdomain/:pageId?"
            render={({
              match: {
                params: { subdomain },
              },
            }) => <Preview branding linkPrefix={`/preview/${subdomain}`} />}
          />
          <Route
            path="/preview-brandoff/:subdomain/:pageId?"
            render={({
              match: {
                params: { subdomain },
              },
            }) => <Preview branding={false} linkPrefix={`/preview-brandoff/${subdomain}`} />}
          />
          <Route path="/*" component={Admin} />
        </Switch>
      </MenuProvider>
    </BrowserRouter>
  </ApolloProvider>,
);
